import { useInfiniteQuery } from '@tanstack/react-query'
import { supabase } from '../../api'

const getFollowingSalons = async (
  id: string,
  limit?: number,
  search?: string,
  pageParam?: number | undefined,
) => {
  const from = pageParam || 0
  const to = from + (limit || 10) - 1

  let req = supabase
    .from('following_salons')
    .select(`
      *,
      salon:salons_profile!salon_id (*)
    `, { count: 'exact' })
    .eq('user_id', id)
    .order('created_at', { ascending: false })

  if (search) {
    req = req.or(
      `name.ilike.%${search}%,username.ilike.%${search}%`,
      { foreignTable: 'salon' },
    )
  }

  const { data, error } = await req.range(from, to)

  if (error) {
    throw new Error(error.message)
  }

  return data
}

export default function useUserFollowingSalonsList(id: string, limit?: number, search?: string) {
  return useInfiniteQuery({
    queryKey: ['useUserFollowingSalonsList', id],
    queryFn: ({ pageParam }) => getFollowingSalons(id, limit, search, pageParam),
    enabled: Boolean(id),
    staleTime: 60000,
    getPreviousPageParam: () => undefined,
    getNextPageParam: (lastPage: any, pages?: any[]) => (
      lastPage.length
        ? (pages || []).reduce((acc, v) => (acc + (v?.length || 0)), 0)
        : undefined
    ),
  })
} 